export const SERVICE_PAYER_CODE = {
  Insurance: "insurance",
  SelfPay: "self-pay",
} as const;

export type ServicePayerCode = (typeof SERVICE_PAYER_CODE)[keyof typeof SERVICE_PAYER_CODE];
